import { handleResponse, handleError } from "./apiUtils";
import Config from "../Config";

export async function postAbusereport(body) {
    return fetch(
    Config.apiUrl + 
      "UserCompany/SendMailOfAbusereport",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body,
      }
    )
      .then(handleResponse)
      .catch(handleError);
  }


  export async function postsendemailchat(body) {
    return fetch(
    Config.apiUrl + 
      "emailChatMessage/CreateEmailChatMessageByEndUser",
      {
        method: "POST",
        // headers: {
        //   "Content-Type": "application/json",
        // },
        body,
      }
    )
      .then(handleResponse)
      .catch(handleError);
  }